// supported video link types from node_modules/react-player/dist/players.js
const AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
const VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
const MATCH_URL_MUX = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/;
const MATCH_URL_YOUTUBE =
  /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
const MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
const MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
const MATCH_URL_SPOTIFY = /open\.spotify\.com\/(\w+)\/(\w+)/i;
const MATCH_URL_TWITCH = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+|(videos?\/|\?video=)\d+)($|\?)/;
const MATCH_URL_TIKTOK = /tiktok\.com\/(?:player\/v1\/|share\/video\/|@[^/]+\/video\/)([0-9]+)/;

const canPlayFile = (url: string, test: (url: string) => boolean) => {
  return test(url);
};

const formats = {
  html: (url: string) => canPlayFile(url, (u) => AUDIO_EXTENSIONS.test(u) || VIDEO_EXTENSIONS.test(u)),
  hls: (url: string) => canPlayFile(url, (u) => HLS_EXTENSIONS.test(u)),
  dash: (url: string) => canPlayFile(url, (u) => DASH_EXTENSIONS.test(u)),
  mux: (url: string) => MATCH_URL_MUX.test(url),
  youtube: (url: string) => MATCH_URL_YOUTUBE.test(url),
  vimeo: (url: string) => MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url),
  wistia: (url: string) => MATCH_URL_WISTIA.test(url),
  spotify: (url: string) => MATCH_URL_SPOTIFY.test(url),
  twitch: (url: string) => MATCH_URL_TWITCH.test(url),
  tiktok: (url: string) => MATCH_URL_TIKTOK.test(url),
};

export enum LinkProviders {
  html = 'html',
  hls = 'hls',
  dash = 'dash',
  mux = 'mux',
  youtube = 'youtube',
  vimeo = 'vimeo',
  wistia = 'wistia',
  spotify = 'spotify',
  twitch = 'twitch',
  tiktok = 'tiktok',
}

export const getLinkType = (url: string): LinkProviders | undefined => {
  switch (true) {
    case formats.html(url): {
      return LinkProviders.html;
    }
    case formats.hls(url): {
      return LinkProviders.hls;
    }
    case formats.dash(url): {
      return LinkProviders.dash;
    }
    case formats.mux(url): {
      return LinkProviders.mux;
    }
    case formats.youtube(url): {
      return LinkProviders.youtube;
    }
    case formats.vimeo(url): {
      return LinkProviders.vimeo;
    }
    case formats.wistia(url): {
      return LinkProviders.wistia;
    }
    case formats.spotify(url): {
      return LinkProviders.spotify;
    }
    case formats.twitch(url): {
      return LinkProviders.twitch;
    }
    case formats.tiktok(url): {
      return LinkProviders.tiktok;
    }
  }
};
